export type BookTypeFormat = "ebook" | "audiobook";

export const BOOK_TYPE_LABELS: Record<BookTypeFormat, string> = {
  ebook: "Електронна книга",
  audiobook: "Аудіокнига",
};

export const formatBookType = (type?: string): string => {
  if (!type) return "";
  return BOOK_TYPE_LABELS[type.toLowerCase() as BookTypeFormat] ?? type;
};

export const getPurchaseActionLabel = (type?: string): string =>
  type?.toLowerCase() === "audiobook"
    ? "Придбати та слухати в застосунку"
    : "Придбати і читати в застосунку";
